import React from 'react';
import { motion } from 'framer-motion';
import { Target, GitBranch, Users, CheckCircle } from 'lucide-react';
const steps = [{
  icon: Target,
  number: '1',
  title: 'Set the Goal',
  description: "You define a clear, measurable goal you're trying to hit: views, CTR, conversions, growth, etc.",
  visual: <div className="bg-navy-950 p-3 rounded-lg border border-slate-800" data-id="element-309">
        <div className="flex items-center gap-2 p-2 rounded bg-mint-500/10 border border-mint-500/20" data-id="element-310">
          <Target className="w-3 h-3 text-mint-500" data-id="element-311" />
          <div data-id="element-312">
            <div className="text-[8px] text-slate-500 uppercase font-bold" data-id="element-313">
              Goal
            </div>
            <div className="text-[10px] text-white font-semibold" data-id="element-314">
              100K views in 7 days
            </div>
          </div>
        </div>
      </div>
}, {
  icon: GitBranch,
  number: '2',
  title: 'Offer A/B/C Paths',
  description: "You present real options you'd actually take—different paths to reach the goal.",
  visual: <div className="bg-navy-950 p-3 rounded-lg border border-slate-800" data-id="element-315">
        <div className="space-y-1.5" data-id="element-316">
          <div className="flex items-center gap-2 px-2 py-1.5 rounded bg-slate-800 border border-slate-700" data-id="element-317">
            <div className="w-4 h-4 rounded bg-mint-500/20 text-mint-500 text-[8px] font-bold flex items-center justify-center" data-id="element-318">
              A
            </div>
            <div className="text-[10px] text-slate-300" data-id="element-319">Long-form</div>
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded bg-slate-800 border border-slate-700" data-id="element-320">
            <div className="w-4 h-4 rounded bg-slate-700 text-slate-400 text-[8px] font-bold flex items-center justify-center" data-id="element-321">
              B
            </div>
            <div className="text-[10px] text-slate-400" data-id="element-322">Challenge</div>
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded bg-slate-800 border border-slate-700" data-id="element-323">
            <div className="w-4 h-4 rounded bg-slate-700 text-slate-400 text-[8px] font-bold flex items-center justify-center" data-id="element-324">
              C
            </div>
            <div className="text-[10px] text-slate-400" data-id="element-325">Collab</div>
          </div>
        </div>
      </div>
}, {
  icon: Users,
  number: '3',
  title: 'Audience Commits',
  description: 'Your audience commits Points to the path they believe will hit the goal, building reputation over time.',
  visual: <div className="bg-navy-950 p-3 rounded-lg border border-slate-800" data-id="element-326">
        <div className="space-y-2" data-id="element-327">
          <div className="flex justify-between items-center text-[10px]" data-id="element-328">
            <span className="text-slate-400" data-id="element-329">2.8k Takes</span>
            <span className="text-mint-500 font-bold" data-id="element-330">+500 Pts</span>
          </div>
          <div className="w-full bg-slate-800 rounded-full h-2" data-id="element-331">
            <div className="bg-gradient-to-r from-mint-500 to-wave-500 w-[65%] h-full rounded-full" data-id="element-332" />
          </div>
          <div className="flex justify-between text-[9px] text-slate-500" data-id="element-333">
            <span data-id="element-334">Reputation building</span>
            <span data-id="element-335">125k Pts total</span>
          </div>
        </div>
      </div>
}, {
  icon: CheckCircle,
  number: '4',
  title: 'Resolve & Learn',
  description: 'When the deadline hits, the market resolves objectively. You see what worked, who called it, and what to do next.',
  visual: <div className="bg-navy-950 p-3 rounded-lg border border-mint-500/30" data-id="element-336">
        <div className="flex items-center justify-between mb-2" data-id="element-337">
          <div className="flex items-center gap-1.5" data-id="element-338">
            <CheckCircle className="w-3 h-3 text-mint-500" data-id="element-339" />
            <span className="text-[10px] text-mint-500 font-bold" data-id="element-340">
              RESOLVED
            </span>
          </div>
          <span className="text-[10px] text-mint-500 font-bold" data-id="element-341">
            +1,200 Pts
          </span>
        </div>
        <div className="space-y-1" data-id="element-342">
          <div className="flex items-center gap-2" data-id="element-343">
            <div className="w-3 h-3 rounded bg-mint-500/20 text-mint-500 text-[8px] font-bold flex items-center justify-center" data-id="element-344">
              ✓
            </div>
            <div className="text-[10px] text-white" data-id="element-345">Long-form won</div>
          </div>
          <div className="text-[9px] text-slate-500" data-id="element-346">Top caller: @SuperFan</div>
        </div>
      </div>
}];
const sagaBeats = [{
  label: 'Tease the goal',
  caption: 'Post the goal + deadline'
}, {
  label: 'Drop the paths',
  caption: 'Let them choose the move'
}, {
  label: 'Share momentum',
  caption: 'Post takes + live updates'
}, {
  label: 'Announce the result',
  caption: 'Resolve + reward top callers'
}, {
  label: 'Tee up the next one',
  caption: "Show what you're doing next"
}];
export function IntroducingPulseMarkets() {
  return <section className="py-20 lg:py-32 bg-navy-950 border-t border-slate-800" data-id="element-347">
      <div className="max-w-7xl mx-auto px-6" data-id="element-348">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-349">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-350">
            <h2 className="text-3xl lg:text-5xl font-bold mb-6" data-id="element-351">
              Introducing,{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-mint-500 to-wave-500" data-id="element-352">
                Pulse Markets
              </span>
            </h2>
            <p className="text-lg text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-353">
              Pulse Markets are goal-driven decisions you run with your
              audience. Unlike polls or surveys, they align participation around
              what you're trying to achieve—so feedback turns into commitment,
              signal, and outcomes.
            </p>
          </motion.div>
        </div>

        {/* 4-Step Process */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-16" data-id="element-354">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-navy-900 rounded-xl p-6 border border-slate-800" data-id="element-355">
                <div className="flex items-center gap-3 mb-4" data-id="element-356">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-mint-500/10 to-wave-500/10 border border-slate-700 flex items-center justify-center" data-id="element-357">
                    <Icon className="w-5 h-5 text-mint-500" data-id="element-358" />
                  </div>
                  <div className="w-6 h-6 rounded-full bg-navy-950 border border-slate-700 flex items-center justify-center text-xs font-bold text-slate-400" data-id="element-359">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-360">
                  {step.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed mb-4" data-id="element-361">
                  {step.description}
                </p>
                <div className="mt-auto" data-id="element-362">{step.visual}</div>
              </motion.div>;
        })}
        </div>

        {/* Content Saga — simplified timeline */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="relative mb-14" data-id="element-363">
          {/* Section label */}
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-364">
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-slate-700" data-id="element-365" />
            <span className="text-[11px] font-bold text-slate-500 uppercase tracking-widest" data-id="element-366">
              Content at every step
            </span>
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-slate-700" data-id="element-367" />
          </div>

          {/* Timeline row */}
          <div className="relative flex items-start justify-between max-w-4xl mx-auto" data-id="element-368">
            {/* Connecting line */}
            <div className="absolute top-[5px] left-[8%] right-[8%] h-px bg-gradient-to-r from-mint-500/30 via-wave-500/30 to-mint-500/30" data-id="element-369" />

            {sagaBeats.map((beat, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + idx * 0.06
          }} className="flex flex-col items-center text-center relative z-10 flex-1" data-id="element-370">
                {/* Dot */}
                <div className="w-[10px] h-[10px] rounded-full bg-gradient-to-r from-mint-500 to-wave-500 mb-3 shadow-[0_0_6px_rgba(80,242,181,0.25)]" data-id="element-371" />
                {/* Label */}
                <div className="text-[11px] font-semibold text-slate-200 mb-0.5 leading-tight" data-id="element-372">
                  {beat.label}
                </div>
                {/* Caption */}
                <div className="text-[10px] text-slate-500 leading-tight max-w-[100px]" data-id="element-373">
                  {beat.caption}
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Payoff line */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center" data-id="element-374">
          <p className="text-lg text-slate-300 font-medium" data-id="element-375">
            Each Pulse Market is instant content.
          </p>
        </motion.div>
      </div>
    </section>;
}